export { StyledMenuItemTag, MenuItemTag } from './src/menu-item-tag';
